// @deprecated
enum ModalSize {
    LARGE = 'large',
    MEDIUM = 'medium',
    WIDE = 'wide',
}

export default ModalSize;
